import React, {useEffect} from 'react'
import VisionCarousel from '../components/Vision Carousel';
import MissionCarousel from '../components/Mission Carousel';
// import ValuesAccordion from '../components/ValuesAccordion';
import CoreValues from '../components/CoreValues';
const WhoWeAre = () => {

useEffect(()=>{
document.title = 'Who We Are | RAK ENGINEERING LTD';

},[]);


  return (
    <>

     
    <section className='section-cover who-we-are-cover' >
      <h2 className="home-h2 wwa-h2">Who We Are</h2>
          <div className='content-container vm-container'>
                 <div className='vision-mission-content'>
                    <article className='vision-mission-slides'>
                          <VisionCarousel></VisionCarousel>

                    </article>

                    <article className='vision-mission-info'>
                          <h3 className='title-h3'>Vision</h3>
                          <div className='vm-line'></div>
                          <p>To be the provider of superior customer service through application of technological innovations that optimize resource utilization and environmental conservation.</p>
                          
                          <h3 className='title-h3'>Mission</h3>
<div className='vm-line'></div>
                          <p>To continuously offer relevant, safe, affordable and environmentally acceptable Engineering solutions that meet customer and societal needs by engaging in research and innovation.</p>

                    </article>

                    


                 </div>

                 <div className='vision-mission-content mission-info'>

                  <article className='vision-mission-slides'>
                         
                       <MissionCarousel></MissionCarousel>
                    </article>

                    <article className='vision-mission-info '>
<h3 className='title-h3'>Core Values</h3>
<div className='vm-line'></div>
           <CoreValues></CoreValues>

                    </article>


                 </div>
          </div>
    </section>
    

    </>
  )
}

export default WhoWeAre